export default __webpack_public_path__ + "vision-overview-header-image-960-7c0127cade25da7db5c711e004c5dd01.png";